import * as variables from './variables';

export const FormField = () => {
  return `
    background-color: white;
    border-radius: 22px;
    padding: 0px 16px;
    height: 45px;
    display: inline-block;
    width: 100%;
    font-size: 18px;

    &:disabled {
      opacity: 0.5;
      background-color: #efefef;
      cursor: not-allowed;
    }

    &:focus {
      outline: none;
      border-color: white;
      box-shadow: 0px 0px 10px #45cdf4;
    }
  `
}

export const removeFocusOutline = () => {
  return `&:focus { outline: none; }`
}

export const spaceBetween = () => {
  return `
    display: flex;
    justify-content: space-between;
  `
}

export const buttonStyles = () => {
  return `
    padding: 10px 32px;
    box-shadow: 0px 10px 25px rgba(0,0,0,0.2);
    cursor: pointer;
    text-align: center;
    border-radius: 22.5px;
    display: inline-block;
    line-height: ${(25/16)};
    color: ${variables.colours.white};
    font-weight: 500;
    word-break: none;
    white-space: nowrap;
    margin-left: 10px;
    text-decoration: none;
  `
}
